import moment from 'moment';

import { UPDATE_SESSION_TIMESTAMP } from 'state/sessionTimer/SessionTimerActions';
import {
  DECREASE_STEP,
  INCREASE_STEP,
  SET_STEP
} from 'state/steps/StepActions';

export const sessionTimerTimestampInitialState = moment();

export const sessionTimerReducer = (state = sessionTimerTimestampInitialState, action) => {
  const { type } = action;

  if(type === UPDATE_SESSION_TIMESTAMP || type === SET_STEP || type === INCREASE_STEP || type === DECREASE_STEP) {
    const currentTime = moment();
    const lastRequestTime = state;

    if(currentTime.isSameOrAfter(lastRequestTime)) {
      return currentTime;
    }
  }

  return state;
}